import React, { type ReactNode } from 'react';
import { site } from '../data/landing';
type CtaButtonProps = {
  children: ReactNode;
  href?: string;
  variant?: 'green' | 'dark';
  size?: 'md' | 'lg';
  className?: string;
};
const variants = {
  green: 'bg-success hover:bg-success-dark shadow-lg shadow-success/30 focus-visible:ring-success/40',
  dark: 'bg-ink hover:bg-ink-deep shadow-xl shadow-black/30 focus-visible:ring-white/60'
};
const sizes = {
  md: 'px-4 py-2.5 text-sm',
  lg: 'w-full sm:w-auto px-4 py-4 text-[14px] sm:px-8 sm:py-5 sm:text-lg'
};
export function CtaButton({
  children,
  href = site.checkoutUrl,
  variant = 'green',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  return <a href={href} className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl font-extrabold uppercase tracking-tight text-white transition-[transform,background-color] duration-150 ease-out active:scale-[0.97] focus-visible:outline-none focus-visible:ring-4 ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-39" data-mp="vbk605d12559">
      {children}
    </a>;
}